var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconContactUs = function SvgIconContactUs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.058 14.9341C15.8864 14.9341 16.558 14.2625 16.558 13.4341C16.558 12.6057 15.8864 11.9341 15.058 11.9341C14.2296 11.9341 13.558 12.6057 13.558 13.4341C13.558 14.2625 14.2296 14.9341 15.058 14.9341Z",
    fill: "#F27C25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.058 14.9341C21.8864 14.9341 22.558 14.2625 22.558 13.4341C22.558 12.6057 21.8864 11.9341 21.058 11.9341C20.2296 11.9341 19.558 12.6057 19.558 13.4341C19.558 14.2625 20.2296 14.9341 21.058 14.9341Z",
    fill: "#F27C25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.058 14.9341C9.88643 14.9341 10.558 14.2625 10.558 13.4341C10.558 12.6057 9.88643 11.9341 9.058 11.9341C8.22957 11.9341 7.558 12.6057 7.558 13.4341C7.558 14.2625 8.22957 14.9341 9.058 14.9341Z",
    fill: "#F27C25"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.862 0C6.653 0 0 5.988 0 13.375C0.0239182 15.2965 0.480554 17.1878 1.33597 18.9085C2.19139 20.6292 3.42359 22.135 4.941 23.314L2.972 28.237L10.9 26.255C12.1953 26.5827 13.5259 26.7506 14.862 26.755C23.07 26.755 29.724 20.767 29.724 13.38C29.724 5.993 23.07 0 14.862 0ZM14.862 25.265C13.6481 25.261 12.4392 25.1092 11.262 24.813L10.902 24.724L10.542 24.814L5.432 26.09L6.321 23.866L6.728 22.849L5.876 22.159C4.53395 21.1163 3.44288 19.7859 2.68312 18.2657C1.92337 16.7455 1.51429 15.0742 1.486 13.375C1.486 6.82 7.486 1.486 14.861 1.486C22.236 1.486 28.237 6.82 28.237 13.375C28.237 19.93 22.237 25.265 14.862 25.265Z",
    fill: "#F27C25"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconContactUs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_contact_us.23b73c18.svg";
export { ForwardRef as ReactComponent };